import SafeReact from 'util/SafeReact.js'

const Switch = ({
    children, view, cleanProps = (props) => props, ...props
}) => SafeReact.cloneChildren(children[view(props)], cleanProps(props))

export default Switch
